export default {
  PREVIEW_TYPE_IMAGE: 'image',
  PREVIEW_TYPE_PRESCRIPTION: 'prescription',
  PREVIEW_TYPE_PRESCRIPTION_FILE: 'prescriptionFile',
  PREVIEW_TYPE_SC_PWD_ID_FILE: 'scPwdIdFile',
  PREVIEW_TYPE_LAB_REQUEST: 'labrequest'
}